import './index.scss';
import React, { useState } from 'react';
import {
  withSitecoreContext,
  Field,
  RichText,
  LinkFieldValue,
} from '@sitecore-jss/sitecore-jss-react';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

type AlphabeticalLandingProps = {
  fields: {
    items: PageProps[];
  };
  sitecoreContext: {
    pageEditing: boolean;
    language: string;
  };
};

type PageProps = {
  url: Field<string>;
  fields: {
    'List Title': Field<string>;
    'List Description': Field<string>;
    Link: Field<LinkFieldValue>;
  };
};

type Alphabets = {
  [key: string]: string[];
};

const alphabets: Alphabets = {
  en: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
  hr: 'A,B,C,Č,Ć,D,Dž,Đ,E,F,G,H,I,J,K,L,Lj,M,N,Nj,O,P,R,S,Š,T,U,V,Z,Ž'.split(','),
  it: 'ABCDEFGHILMNOPQRSTUVZ'.split(''),
};

const specialCharacters = ['Dž', 'Lj', 'Nj'];

const AlphabeticalLanding: React.FC<AlphabeticalLandingProps> = ({ fields, sitecoreContext }) => {
  const { t, i18n } = useTranslation();
  const language = sitecoreContext.language || 'en';
  let returnToTop = t('return-to-top-button-text');

  const handleLetterClick = (letter: string) => {
    document.getElementById(letter)?.scrollIntoView({ behavior: 'smooth' });
  };
  const handleScrollToTop = () => {
    const alphaListElement = document.querySelector('.alpha-wrapper');
    if (alphaListElement) {
      alphaListElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const groupedPages: { [key: string]: PageProps[] } = {};
  fields.items.forEach((proxy) => {
    if (proxy?.fields?.['List Title']?.value) {
      let firstLetter = proxy?.fields?.['List Title'].value.substring(0, 2);
      if (!specialCharacters.includes(firstLetter)) {
        firstLetter = proxy?.fields?.['List Title'].value[0].toUpperCase();
      }
      if (!groupedPages[firstLetter]) {
        groupedPages[firstLetter] = [];
      }
      groupedPages[firstLetter].push(proxy);
    }
  });

  const sortedLetters = alphabets[language].filter((letter) => groupedPages[letter]);

  if (fields) {
    return (
      <>
        <div className="alpha-landing-wrapper">
          {sitecoreContext.pageEditing && (
            <>
              <p>Alphabetical Landing Component Edit Mode</p>
            </>
          )}
          <div className="alpha-wrapper">
            <div className="alpha-list">
              {alphabets[language].map((letter) =>
                sortedLetters.includes(letter) ? (
                  <a key={letter} onClick={() => handleLetterClick(letter)}>
                    {letter}
                  </a>
                ) : (
                  <span key={letter} className="grayed-out">
                    {letter}
                  </span>
                )
              )}
            </div>
          </div>
          <div className="pages-list">
            {sortedLetters.map((letter) => (
              <div key={letter} id={letter} className="letter-section">
                <hr className="divider" />
                <span className="letter">{letter}</span>
                <div className="page-grid">
                  {groupedPages[letter].map((page, index) => (
                    <div key={index} className="page-item">
                      <a className="page-link" href={page?.fields?.Link?.value?.href}>
                        <span className="page-title">{page.fields['List Title'].value}</span>
                      </a>
                      <div className="page-description">
                        <RichText field={page.fields['List Description']}></RichText>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <div className="button-wrapper">
            {returnToTop ? (
              <Button color="secondary" variant="contained" onClick={handleScrollToTop}>
                {returnToTop}
              </Button>
            ) : null}
          </div>
        </div>
      </>
    );
  } else if (!fields && sitecoreContext.pageEditing) {
    return <p>Please setup the Datasource.</p>;
  }
  return <></>;
};

export default withSitecoreContext()(AlphabeticalLanding);
